import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container-9" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, null, -1)
const _hoisted_3 = { class: "sm:col-span-4 main-content text-3xl" }
const _hoisted_4 = {
  key: 0,
  class: "question-label"
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 3,
  class: "p-4 w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Bar = _resolveComponent("Bar")!
  const _component_BackNextButtons = _resolveComponent("BackNextButtons")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content", _ctx.config.classes?.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            (_ctx.config.title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _withDirectives(_createElementVNode("span", null, null, 512), [
                    [_directive_t, _ctx.config.title]
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.config.textPart1)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 1,
                  class: "mt-4",
                  innerHTML: _ctx.$rt(_ctx.config.textPart1, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_5))
              : _createCommentVNode("", true),
            (_ctx.config.textPart2)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 2,
                  class: "mt-4",
                  innerHTML: _ctx.$rt(_ctx.config.textPart2, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_6))
              : _createCommentVNode("", true),
            (_ctx.chartReady)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_Bar, {
                    style: {"width":"100%"},
                    id: "my-chart-id",
                    options: _ctx.chartOptions,
                    data: _ctx.chartData
                  }, null, 8, ["options", "data"])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_BackNextButtons, {
              "go-to": _ctx.goTo,
              "next-screen": _ctx.config.screenNext,
              class: "mt-8 hidden sm:block"
            }, null, 8, ["go-to", "next-screen"])
          ]),
          _createElementVNode("div", {
            class: "col-span-4 h-full flex-col items-center flex justify-center relative",
            style: _normalizeStyle(`background-image: ${_ctx.config.bgImage}; background-size: cover; background-position: center;`)
          }, [
            _createVNode(_component_BackNextButtons, {
              "go-to": _ctx.goTo,
              "next-screen": _ctx.config.screenNext,
              class: "mt-8 sm:hidden block"
            }, null, 8, ["go-to", "next-screen"])
          ], 4)
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ], 2))
}